module.exports = __webpack_public_path__ + "img/1.98327028.jpg";